import { render } from "./PromotionFormModal.vue?vue&type=template&id=7b8a84ae"
import script from "./PromotionFormModal.vue?vue&type=script&lang=js"
export * from "./PromotionFormModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__